import validate from "/src/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/src/app/middleware/auth.global.ts";
import settings_45routes_45global from "/src/app/middleware/settings-routes.global.ts";
import manifest_45route_45rule from "/src/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  settings_45routes_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}